// TODAS AS CONSTANTES DE EVENTOS, COMO 'CLICK', 'SCREEN_VIEW', 'EXCEPTION' E ETC.
export enum AnalyticsConstantsEvents {
  event_name_screen_view = 'screen_view',
  event_name_click = 'click',
  event_name_exception = 'exception',
  event_name_search = 'search',
  event_name_visualization = 'visualization',
  event_name_alert = 'alert',
}
